import {type Issue} from './types';

const DEFAULT_ISSUE_DESCRIPTION =
  'During training, GPU utilization dropped while CPU and disk usage stayed high, indicating a data loading bottleneck likely due to insufficient data loader workers or slow disk reads. This reduced overall training speed.';

function buildIssueLinkURL(issue: Issue): string {
  return `https://cks-grafana.coreweave.com/d/ddbdicm9sw7c5x/node-details?orgId=1&var-node=${issue.node}&from=${issue.timestamp}&to=${issue.timestamp}`;
}

export function normalizeIssues(issues: Issue[]): Issue[] {
  return [...issues]
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((issue, i) => ({
      ...issue,
      description: issue.description ?? DEFAULT_ISSUE_DESCRIPTION,
      id: issue.id ?? `${issue.alertName}-${issue.timestamp}-${i}`,
      linkURL: issue.linkURL ?? buildIssueLinkURL(issue),
      timestamp:
        issue.timestamp ??
        parseInt(Object.keys(issue.occurrences ?? {}).sort()[0]),
      title: issue.title ?? issue.alertName,
    }));
}
